import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import {
    SpsMicroZeroStateComponent,
    SpsZeroStateComponent,
} from "../components/index";

@NgModule({
    imports: [CommonModule],
    exports: [SpsZeroStateComponent, SpsMicroZeroStateComponent],
    declarations: [SpsZeroStateComponent, SpsMicroZeroStateComponent],
    providers: []
})
export class SpsZeroStateModule {}
